import { Component, OnDestroy } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { TranslateService } from '@ngx-translate/core';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'btn-cell-rendererCilMaster',
  template: `
    <button *ngIf = "params.node.data.InActive"
     mat-mini-fab color="primary"
     tooltipPosition="top"
     [pTooltip]="t('EditTask', 'Edit Task')"
     (click)="onClick($event)">
      <mat-icon>edit</mat-icon>
    </button>
    <button *ngIf = "!params.node.data.Executed"
      mat-mini-fab
      tooltipPosition="top"
      [pTooltip]="t('DeleteTask', 'Delete Task')"
      color="warn"
      (click)="onClick($event)"
    >
      <mat-icon>delete</mat-icon>
    </button>
  `,
  styles: [
    ` button{
      height: 35px;
      width: 35px;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      margin: 0 3px;

    }
    .mat-icon {
      transform: scale(0.7);
    }
      .add-icon {
        background: cornflowerblue;
      }
    `,
  ],
})
// tslint:disable-next-line:component-class-suffix
export class BtnCellRendererCilMaster
  implements ICellRendererAngularComp, OnDestroy {

  /** i18n section for the host page */
  private readonly PAGE = 'CILConfiguration';

  constructor(public translate: TranslateService) {}

  /** langObj (via cellRendererParams.getLangObj) -> "<PAGE>.<key>" -> flat key -> English. */
  t(key: string, fallback: string): string {
    const langObj =
      this.params && typeof this.params.getLangObj === 'function'
        ? this.params.getLangObj()
        : null;
    if (langObj && langObj[key]) {
      return langObj[key];
    }
    for (const candidate of [`${this.PAGE}.${key}`, key]) {
      const value = this.translate.instant(candidate);
      if (typeof value === 'string' && value !== candidate) {
        return value;
      }
      if (value && typeof value === 'object' && typeof value.title === 'string') {
        return value.title;
      }
    }
    return fallback;
  }
  clicked = false;
   params: any;
  refresh(params: any): boolean {
    // Returning false tells ag-Grid to destroy and rebuild this cell, which
    // re-runs agInit and re-resolves the tooltips. It must not throw: the page
    // calls refreshCells({ force: true }) when the language changes.
    return false;
  }
  agInit(params: any): void {
    this.params = params;
  }
  onClick($event: any): any {
    const spec = $event.target.className;
    if (
      spec !== 'Delete' &&
      spec !== 'close' &&
      this.params.node.data.ObservationStatus.toLowerCase() !== 'in progress'
    ) {
      if (this.params.onClick instanceof Function) {
        // put anything into params u want pass into parents component
        const params = {
          event: $event,
          rowData: this.params.node.data,
          // ...something
        };
        this.params.onClick(params);
      }
    } else {
      this.clicked = true;
    }
  }
  ngOnDestroy(): any {
    // no need to remove the button click handler
    // https://stackoverflow.com/questions/49083993/does-angular-automatically-remove-template-event-listeners
  }
}
